/** Firestore path: `counters/inventory_lead_numbers` with `{ next: number }`. */
export const INVENTORY_LEAD_NUMBER_COUNTER_COLLECTION = "counters";
export const INVENTORY_LEAD_NUMBER_COUNTER_DOC_ID = "inventory_lead_numbers";

const INVENTORY_LEAD_NUMBER_PATTERN = /^IL(\d{2})-(\d{5})$/;

/** Human-readable inventory lead id, e.g. `IL26-00042`. */
export const formatInventoryLeadNumber = (
  sequence: number,
  createdAt: Date,
): string => {
  const yearSuffix = (createdAt.getFullYear() % 100).toString().padStart(2, "0");
  const paddedSequence = Math.max(1, Math.floor(sequence))
    .toString()
    .padStart(5, "0");
  return `IL${yearSuffix}-${paddedSequence}`;
};

/** Parses the trailing sequence from an inventory lead number, or null if invalid. */
export const parseInventoryLeadNumberSequence = (
  leadNumber: string | null | undefined,
): number | null => {
  const trimmed = leadNumber?.trim();
  if (!trimmed) return null;
  const match = trimmed.match(INVENTORY_LEAD_NUMBER_PATTERN);
  if (!match) return null;
  const sequence = Number(match[2]);
  return Number.isFinite(sequence) ? sequence : null;
};
